import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";

import { Row, Col, CardBody, Card, Container, Label, Form, FormFeedback, Input } from "reactstrap";

// Redux
import { connect, useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';

import { toast } from "react-toastify";

import './login.css';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, apiError } from "../../store/actions";

// Images
import bg from "../../assets/images/bg.png";
import logoDark from "../../assets/images/logo.png";

const Login = props => {
  const dispatch = useDispatch();
  const [animateLogo, setAnimateLogo] = useState(false);
  const [animationDone, setAnimationDone] = useState(false);

  const [userLogin, setUserLogin] = useState({
    email: '',
    password: ''
  });

  const { user, loading } = useSelector(state => ({
    user: state.Account.user,
    loading: state.Login.loading,
  }));

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimateLogo(true);
      setTimeout(() => setAnimationDone(true), 1000);
    }, 20);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (user && user) {
      setUserLogin({
        email: user.email,
        password: user.password
      });
    }

    if (props.error) {
      toast.error(props.error, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [user, props.error]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email,
      password: userLogin.password,
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    }
  });

  document.title = "Login | Welcome To Moeen";
  return (
    <React.Fragment>
      {/* Overlay for logo animation */}
      {!animationDone && (
        <div className={`logo-overlay ${animateLogo ? "hidden" : ""}`}>
          <img
            src={logoDark}
            alt="logo"
            className={`logo-img ${animateLogo ? "animate" : ""}`}
          />
        </div>
      )}

      <div className={`account-pages ${!animationDone ? "d-none" : ""}`}>
        <div
          className="accountbg"
          style={{
            background: `url(${bg})`,
            backgroundSize: "cover",
            backgroundPosition: "right center",
          }}
        ></div>

        <div className="wrapper-page account-page-full">
          <Card className="shadow-none">
            <div className="card-block">
              <div className="account-box" id="login-panel">
                <div className="card-box shadow-none p-4">
                  <div className="p-2">
                    <div className="text-center">
                      <Link to="/">
                        <img src={logoDark} id="login-logo" height="100" alt="logo" />
                      </Link>
                    </div>

                    <h4 className="font-size-18 text-center">Welcome Back!</h4>
                    <p className="text-muted text-center">
                      Sign in to continue to Sawari Online.
                    </p>

                    <form
                      className="mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                      }}
                      action="#"
                    >
                      {/* Email Field */}
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="email">
                          Email Address
                        </Label>
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter email address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email}
                          invalid={!!(validation.touched.email && validation.errors.email)}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      {/* Password Field */}
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="password">
                          Password
                        </Label>
                        <Input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Enter password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      {/* Remember Me + Login */}
                      <Row className="mb-3">
                        <Col sm={6}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>
                        </Col>
                        <Col sm="6" className="text-end">
                          <button
                            className="btn btn-primary text-white w-md waves-effect waves-light"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </>
                            ) : (
                              "Sign in"
                            )}
                          </button>
                        </Col>
                      </Row>

                      {/* Forgot Password */}
                      {/* <Row className="mb-3 mt-2 mb-0">
                        <Col className="mt-3">
                          <Link to="/pages-recoverpw-2" className="color-success">
                            <i className="mdi mdi-lock"></i> Forgot your password?
                          </Link>
                        </Col>
                      </Row> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};